var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlinking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ef2Bh6mAPoH1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.851303-29.70002)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 141.750934,
    ry: 141.750934,
    transform: "matrix(1.1 0 0 1.1 200.851307 194.244745)",
    fill: "#141c3a",
    stroke: "#4fecec",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M219.37,286.8v-32.8h37.57c9.388841,0,17,7.611159,17,17s-7.611159,17-17,17h-37.57v-1.2",
    fill: "#202c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.09,286.8v-32.8h-37.58c-9.388841,0-17,7.611159-17,17s7.611159,17,17,17h37.57v-1.2",
    fill: "#202c33"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.21,363v-25.2c-.087874-30.201116-24.548884-54.662126-54.75-54.75h-3.46c-10.816629-.032944-19.577056-8.793371-19.61-19.61v-19.71h-50.33v19.74c-.032944,10.816629-8.793371,19.577056-19.61,19.61h-3.45c-30.201116.087874-54.662126,24.548884-54.75,54.75v25.17c0,2.185384.86814,4.28126,2.41344,5.82656s3.641176,2.41344,5.82656,2.41344h189.51c4.539106-.016526,8.21003-3.700864,8.21-8.24Z",
    fill: "#f7c299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.85,282.58h.75c10.097136.011202,20.047003-2.421369,29-7.09-2.692579-3.421262-4.160771-7.646274-4.17-12v-19.76h-50.37v19.74c-.009229,4.353726-1.477421,8.578738-4.17,12c8.938971,4.670052,18.874635,7.109367,28.96,7.11Z",
    fill: "#cf946d"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.42,375h61.16v-77.09c-19.019364,10.559308-42.140636,10.559308-61.16,0Z",
    fill: "#109494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.42,310.87c19.019364,10.559308,42.140636,10.559308,61.16,0",
    fill: "none",
    stroke: "#4fecec",
    strokeWidth: 8.24112,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.49,375.27c-3.250637-.002649-6.366937-1.297187-8.66267-3.598547s-3.582638-5.420819-3.57733-8.671453v-25.2c.090639-26.44996,17.79624-49.598091,43.3-56.61.345476-.093892.701994-.14098,1.06-.14h26c10.267927.011023,18.588977,8.332073,18.6,18.6v71.25c.015577.229736.015577.460264,0,.69-.177034,2.075374-1.917103,3.667537-4,3.66Z",
    fill: "#35444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.33,375.27c-2.082897.007537-3.822966-1.584626-4-3.66-.015607-.229735-.015607-.460265,0-.69v-71.25c.011023-10.267927,8.332073-18.588977,18.6-18.6h26c.358006-.00098.714524.046108,1.06.14c25.50376,7.011909,43.209361,30.16004,43.3,56.61v25.18c.005339,3.259309-1.288424,6.386369-3.594982,8.689174s-5.435722,3.591473-8.695018,3.580826Z",
    fill: "#35444d"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.39,
    y1: 343.8,
    x2: 142.39,
    y2: 362.86,
    fill: "none",
    stroke: "#202c33",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.07,
    y1: 343.8,
    x2: 258.07,
    y2: 362.86,
    fill: "none",
    stroke: "#202c33",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.17,266.24c-.743634,4.862876-4.961114,8.431513-9.88,8.36h-4.37c-12.532075.005295-22.708515,10.128128-22.78,22.66v77.44c0,2.761424,2.238576,5,5,5h.52c2.761424,0,5-2.238576,5-5v-76.11c.033005-5.819728,4.760179-10.520094,10.58-10.52h18.71c9.361572.000079,16.961452-7.568508,17-16.93l-20.47-9.9c.675201,1.574361.913561,3.30161.69,5Z",
    fill: "#202c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,279c-3.903001-2.873557-8.623275-4.422452-13.47-4.42h-4.37c-4.918886.071513-9.136366-3.497124-9.88-8.36-.226706-1.697491.008195-3.424707.68-5l-20.47,9.9c.038548,9.361492,7.638428,16.930079,17,16.93h18.71c5.819821-.000094,10.546995,4.700272,10.58,10.52v76.13c0,2.761424,2.238576,5,5,5h.52c2.761424,0,5-2.238576,5-5v-77.44c-.008739-7.221936-3.463923-14.005985-9.3-18.26Z",
    fill: "#202c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.54,274.66h-4.67c-5.328233-.016471-9.643529-4.331767-9.66-9.66v0c-.001408-1.288388.25708-2.563822.76-3.75",
    fill: "none",
    stroke: "#68717d",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.05,
    y1: 285.85,
    x2: 157.05,
    y2: 332.55,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    r: 7.69,
    transform: "translate(156.82 339.75)",
    fill: "#109494"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.41,
    y1: 285.85,
    x2: 243.41,
    y2: 332.55,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    r: 7.69,
    transform: "translate(243.41 339.98)",
    fill: "#109494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.92,274.66h4.67c5.328233-.016471,9.643529-4.331767,9.66-9.66v0c.001408-1.288388-.25708-2.563822-.76-3.75",
    fill: "none",
    stroke: "#68717d",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M276.38,178v-43.23c-.071297-30.467898-24.732217-55.160091-55.2-55.27h-42.36c-30.467783.109909-55.128703,24.802102-55.2,55.27v43.23",
    fill: "none",
    stroke: "#109494",
    strokeWidth: 14,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.22,
    height: 61.05,
    rx: 16.38,
    ry: 16.38,
    transform: "translate(101.28 154.48)",
    fill: "#109494"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.15,
    y1: 173.26,
    x2: 118.15,
    y2: 196.81,
    fill: "none",
    stroke: "#4fecec",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.22,
    height: 61.05,
    rx: 16.38,
    ry: 16.38,
    transform: "matrix(-1 0 0-1 298.72 215.53)",
    fill: "#109494"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.85,
    y1: 173.26,
    x2: 281.85,
    y2: 196.81,
    fill: "none",
    stroke: "#4fecec",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189,82.68h22c29.005995,0,52.52,23.514005,52.52,52.52v56.07c.002654,14.783061-5.869403,28.961263-16.323544,39.413528s-24.633395,16.321778-39.416456,16.316472h-15.56c-30.773306,0-55.72-24.946694-55.72-55.72v-56.08c-.000002-28.998186,23.501816-52.508957,52.5-52.52Z",
    transform: "translate(-.107127 0)",
    fill: "#f7c299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.78,184.3c-1.419143-2.363024-3.954822-3.829029-6.710774-3.879839s-5.343945,1.320732-6.849226,3.629839",
    transform: "translate(0-.469462)",
    fill: "none",
    stroke: "#cf946d",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,205.46v.29c0,7.29,5.79,13.82,13.84,14.78c9.74,1.16,18.14-5.7,18.14-14.24v-.83c-.129057-2.260745-2.058426-3.993604-4.32-3.88h-23.33c-2.265381-.1193-4.200992,1.615151-4.33,3.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "ef2Bh6mAPoH37",
    rx: 6.88,
    ry: 7.43,
    transform: "translate(231.505 165.83)",
    fill: "#02468e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ef2Bh6mAPoH38",
    rx: 6.88,
    ry: 7.43,
    transform: "translate(168.494515 165.83)",
    fill: "#02468e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 219.84,
    y1: 140.85,
    x2: 243.17,
    y2: 140.85,
    fill: "none",
    stroke: "#77655a",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.83,
    y1: 140.85,
    x2: 181.16,
    y2: 140.85,
    fill: "none",
    stroke: "#77655a",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203.84,73.93h-7.68c-35.45,0-63.52,30.67-63.52,68.15v40.57h9.47v-51.4c.140959-5.143259,4.354815-9.237353,9.5-9.23l3.7.06c.68-10.11,8.92-24.68,18.93-24.68h51.51c10,0,18.24,14.55,18.93,24.66h3.71c5.08,0,9.6,4.15,9.6,9.23v51.4h9.37v-40.61c0-37.48-28.07-68.15-63.52-68.15Z",
    transform: "translate(.608977 0)",
    fill: "#9f8b7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83,53c-.039193-10.58628-8.477664-19.228408-19.06-19.52-2.531847,7.573103-9.400783,12.856292-17.37,13.36h-36.74c-14.617311.043929-26.456071,11.882689-26.5,26.5v4.56c.032944,10.783492,8.766508,19.517056,19.55,19.55h60.57c10.783492-.032944,19.517056-8.766508,19.55-19.55v-11.54c0-.31,0-.61,0-.92s0-.61,0-.92Z",
    transform: "translate(-2.745002 4.050005)",
    fill: "#77655a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.63,152.79v32.85c-.058472,17.102082-13.273851,31.276044-30.33,32.53v-7.44c.083519-10.634988-8.435716-19.341851-19.07-19.49h-17.09c-10.634284.148149-19.153519,8.855012-19.07,19.49v7.44c-17.059971-1.254254-30.276743-15.434068-30.33-32.54v-32.84c-6.076347,7.169127-9.410951,16.262214-9.41,25.66v18.18c.098836,32.61557,26.51443,59.031164,59.13,59.13h16.46c32.596043-.126257,58.981318-26.533862,59.08-59.13v-18.18c.01213-9.392744-3.308088-18.485252-9.37-25.66Zm-65.75,50.3h15.6c4.603825.054925,8.294439,3.826062,8.25,8.43v6.75v0v5.73c-.00037,1.492172-.393544,2.957954-1.14,4.25v0c-.995899,1.456297-2.64574,2.327982-4.41,2.33h-1.43c-2.952441-.005503-5.344497-2.397559-5.35-5.35v-1.44c.016952-1.542874.702922-3.002385,1.88-4h-11.2c1.177078.997615,1.863048,2.457126,1.88,4v1.44c-.005503,2.952441-2.397559,5.344497-5.35,5.35h-1.43c-1.899012-.008751-3.650504-1.025378-4.6-2.67-.643589-1.207287-.986614-2.551947-1-3.92v-12.47c-.021307-2.219746.842148-4.356614,2.399574-5.938433s3.680617-2.478377,5.900426-2.491567Z",
    transform: "translate(-4.164884 0.378625)",
    fill: "#77655a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.24,237.64h-45.24c-8.836556,0-16-7.163444-16-16v-6.14",
    fill: "none",
    stroke: "#4fecec",
    strokeWidth: 12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.73,
    height: 29.46,
    rx: 7.14,
    ry: 7.14,
    transform: "matrix(0 1-1 0 202.03 226.78)",
    fill: "#109494"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlinking);
export default __webpack_public_path__ + "static/media/blinking.39ad7a5fc73a62969e75379f7b1da6ed.svg";
export { ForwardRef as ReactComponent };